
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Customer } from '@/models'
import { useUserStore } from '@/stores/user'

@Component({
  name: 'CustomersTable',
  components: {
    PopoverVerifyCustomer: () => import('./PopoverVerifyCustomer.vue')
  }
})
export default class extends Vue {
  @Prop({ required: true }) customers!: Customer[]
  @Prop({ default: false }) loading!: boolean

  userStore: any = useUserStore()
  deletingId: string | null = null

  get isCaretakerIEG(): boolean {
    return this.userStore.isCaretakerIEG
  }

  initials(customer: Customer): string {
    if (customer.firstname && customer.lastname) {
      return `${customer.firstname.charAt(0)}${customer.lastname.charAt(0)}`
    }
    return '??'
  }

  fullName(customer: Customer): string {
    if (customer.firstname && customer.lastname) {
      return `${customer.firstname} ${customer.lastname}`
    }
    return this.$t('customers.card.notSpecified') as string
  }

  approvalLabel(customer: Customer): string {
    if (customer.registrationStatus === 'verified') return this.$t('customers.card.yes') as string
    if (customer.registrationStatus === 'waiting') return this.$t('customers.card.waiting') as string
    return this.$t('customers.card.no') as string
  }

  approvalTagType(customer: Customer): 'success' | 'warning' | 'danger' {
    if (customer.registrationStatus === 'verified') return 'success'
    if (customer.registrationStatus === 'waiting') return 'warning'
    return 'danger'
  }

  formatLastNativeSignInAt(date: string): string {
    return this.$moment(date).format('DD/MM/YYYY [à] HH:mm')
  }

  async deleteCustomer(customer: Customer): Promise<void> {
    this.deletingId = customer.id
    try {
      await customer.destroy()
      this.$notify({
        title: this.$t('customers.notification.delete.success.title') as string,
        message: this.$t('customers.notification.delete.success.subtitle') as string,
        type: 'success',
        duration: 2000
      })
      this.$emit('delete', customer)
    } catch (e) {
      this.$notify({
        title: this.$t('customers.notification.delete.error.title') as string,
        message: this.$t('customers.notification.delete.error.subtitle') as string,
        type: 'error',
        duration: 2000
      })
    } finally {
      this.deletingId = null
    }
  }
}
